// values defined here should be static, and should NOT use environment variables

export const DEFAULT_TIMEZONE = "Europe/London";

export const SESSION_LIFETIME = 1000 * 60 * 60 * 24 * 35; // 35 days

export const RENT_CLUB_MEMBERSHIP_POINTS_RATE = 0.03;
export const RENT_CLUB_MEMBERSHIP_RATE = 1 / 52;

export const DEPOSIT_FEE_SPREAD_RATE = 2 * (1 / 52);
export const DEPOSIT_CONTRIBUTION_SHARE_RATE = 0.15;

export const DEFAULT_REWARD_POINTS_MULTIPLIER = 1.0;
export const RENT_CLUB_REWARD_POINTS_MULTIPLIER = 3.0;

// used for deposit share and deposit free
export const DEPOSIT_SHARE_BANK_ACCOUNT_NAME = "Scraye Technologies Ltd";
export const DEPOSIT_SHARE_BANK_ACCOUNT_NUMBER = "81524293";
export const DEPOSIT_SHARE_BANK_ACCOUNT_SORT_CODE = "04-00-75";
export const DEPOSIT_SHARE_BANK_ACCOUNT_IBAN = "GB70 REVO 0099 6938 4566 81";
export const DEPOSIT_SHARE_BANK_ACCOUNT_BIC = "REVOGB21";

export const HOW_TO_RENT_GUIDE_URL =
  "https://assets.publishing.service.gov.uk/media/65159e567c2c4a001395e1ea/DLUHC_How_to_rent_Oct2023.pdf";
export const RENTERS_RIGHTS_SHEET_URL =
  "https://assets.publishing.service.gov.uk/media/69bc04b8f7b1c24d8e23ce60/The_Renters__Rights_Act_Information_Sheet_2026.pdf";

export const CHECK_IN_EARNINGS_PER_DEAL = 800; // £8

export const MAX_UPLOAD_FILE_SIZE = 20 * 1024 * 1024;

// Daily time at which reminders are sent for that day's confirmed viewings.
export const VIEWING_REMINDER_TIME = {hour: 8, minute: 0} as const;

// Agent commission rates
/** Standard duration (months) used to convert monthly rent into a commission base under the RRA. */
export const COMMISSION_MONTHS = 12;
/** Viewing agent commission rate applied to 12 months of rent on rental deals. */
export const VIEWING_AGENT_RATE = 0.0095;
/** Agent's share of the tenant guarantor fee. */
export const GUARANTOR_AGENT_SHARE_OF_FEE = 0.2;
/** Tenant-facing guarantor fee rates (annualised — applied to 12 months of rent). */
export const GUARANTOR_TENANT_FEE_RATES = {
  STANDARD: 0.06,
  ENHANCED: 0.075,
} as const;
/** Agent commission rates per guarantor type (annualised). */
export const GUARANTOR_AGENT_RATES = {
  STANDARD: GUARANTOR_TENANT_FEE_RATES.STANDARD * GUARANTOR_AGENT_SHARE_OF_FEE,
  ENHANCED: GUARANTOR_TENANT_FEE_RATES.ENHANCED * GUARANTOR_AGENT_SHARE_OF_FEE,
} as const;
/** Deposit Share agent commission rate applied to 12 months of rent. */
export const DEPOSIT_SHARE_AGENT_RATE = 0.0038;
/** Advanced Rent agent commission rates per upfront period (months). */
export const ADVANCED_RENT_AGENT_RATES: Record<3 | 6 | 12, number> = {
  3: 0.002,
  6: 0.005,
  12: 0.01,
};

export type AdvancedRentProduct = {
  months: number;
  feeRate: number;
  flatFee: number;
};

// Fee values are in pence.
export const ADVANCED_RENT_PRODUCTS: Array<AdvancedRentProduct> = [
  {months: 3, feeRate: 0.02, flatFee: 9950},
  {months: 6, feeRate: 0.05, flatFee: 19950},
  {months: 12, feeRate: 0.0885, flatFee: 29950},
];

export const getAdvancedRentProduct = (months: number) =>
  ADVANCED_RENT_PRODUCTS.find((product) => product.months === months);

export const RIBBON_EMAIL_DOMAIN = "ribbonrewards.io";

export const isRibbonMailbox = (address: string) => address.toLowerCase().endsWith(`@${RIBBON_EMAIL_DOMAIN}`);

export const RIBBON_SUPPORT_EMAIL = "hello@ribbonrewards.io";

export const RIBBON_FOUNDING_LOCAL_REFERRAL_POINTS = 4000;

// Bonus for completing the Ribbon ID check inside the window that opens at signup.
export const RIBBON_VERIFICATION_BONUS_POINTS = 500;
export const RIBBON_VERIFICATION_BONUS_WINDOW_HOURS = 24;
// Paid once when a declined application the win-back email went to is re-submitted, with no time limit.
export const RIBBON_WIN_BACK_BONUS_POINTS = 500;
